import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from 'src/app/services/event.service';
import { rxSetInterval } from '../../utils/shared-common.utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-marquee',
  templateUrl: './marquee.component.html',
  styleUrls: ['./marquee.component.scss']
})
export class MarqueeComponent implements AfterViewInit, OnInit, OnDestroy {
  
  items:string[] = [];
  today = Date.parse(new Date().toString());
  endDate = 1740142800000; // Friday, February 21, 2025 12:59:59 PM
  remainingDays:number = 0;
  currentLanguage?: string;
  isToken = false;
  subscription: Subscription[] = [];

  isRender: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private eventService: EventService,
    private router: Router
  ){
    this.currentLanguage = this.eventService.currentLanguage;
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || "en";
    });
    this.isToken = this.router.url.includes('token');
  }

  ngOnInit(): void {
    this.subscription.push(rxSetInterval(1000).subscribe(()=> this.checkTime()));
  }

  checkTime(){
    this.today = Date.parse(new Date().toString());
    this.remainingDays = this.eventService.getDays(1740095999000 - this.today) + 1;
    if(!!this.remainingDays){
      this.items = Array(25).fill("daysRemaining")
    } else if(this.today > this.endDate){
      this.items = [];
    } else {
      this.items = Array(25).fill("endingToday");
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) this.isRender = true
  }

  routeToToken(){
    this.router.navigate([this.currentLanguage, "token"]);
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subs: Subscription)=> subs.unsubscribe());
  }
}
